import * as React from 'react'
import { IanimationProps } from '../types/index'
import styled from '../theme/styled'

const Wrapper = styled.div`
`
const Image = styled.img`
max-width: 100%;
height: auto;
`
const Loader = styled.div`
display: block;
margin: auto;
margin-top: 100px;
border: 24px solid ${({ theme }) => `${theme.color.lightGrey}`};
border-radius: 80%;
border-top: 24px solid ${({ theme }) => `${theme.color.textLight}`};
width: 64px;
height: 64px;
-webkit-animation: spin 2s linear infinite; /* Safari */
animation: spin 2s linear infinite;

@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`

class Animation extends React.PureComponent<IanimationProps, {}> {

  public render() {
    return (
      <Wrapper>
        {this.props.snapshot[this.props.view][this.props.animationId] ?
          <Image src={`data:image/png;base64,${this.props.snapshot[this.props.view][this.props.animationId].snapshot}`} alt="snapshot" /> :
          <Loader></Loader>}

      </Wrapper>
    )
  }
}

export default Animation



// WEBPACK FOOTER //
// ./src/components/Animation.tsx